var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnvoieEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 1.46875C46.6562 0.15625 49.2812 2.03125 48.9062 4.46875L42.9062 43.5625C42.625 45.5312 40.5625 46.6562 38.7812 45.9062L26.9688 41.0312L21.25 47.9688C19.4688 50.125 16 48.9062 16 46V36.4375L2.78125 31C0.53125 30.0625 0.34375 26.875 2.5 25.6562L44.5 1.46875ZM19 46L24.0625 39.8125L19 37.75V46ZM40 43.1875L46 4L4 28.2812L14.5938 32.6875L38.5 12.25C39.0625 11.7812 39.8125 12.5312 39.3438 13.0938L20.5938 35.125L40 43.1875Z",
    fill: "#E2DA16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvoieEmail);
export default __webpack_public_path__ + "static/media/iconEnvoieEmail.22294e5013473fc85838af3bb0ab7e4b.svg";
export { ForwardRef as ReactComponent };